import PosthogService from '~/services/posthog/PosthogService';
import { CandidateAction } from './types';

// Event-specific interface (co-located)
export interface IPermCandidateListActionClickedPayload {
  postingId: string;
  actionName: CandidateAction;
  professionalId: string;
}

/**
 * Fires when user clicks an action button for a candidate
 * Event: dental_portal:perm_candidate_list:action_clicked
 */
export function firePermCandidateListActionClicked(
  payload: IPermCandidateListActionClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_candidate_list:action_clicked', {
    posting_id: payload.postingId,
    action_name: payload.actionName,
    professional_id: payload.professionalId,
  });
}